import { GetMasterPlansRequest } from './../domain/requests/master-plan.ts/get-master-plans.request';
import { Observable } from 'rxjs';
import { BaseGridResponse } from '../../data/shared/base-grid.response';
import { BaseRequest } from '../../data/shared/base.request';
import {
  AddMasterPlanLocationRequest,
  AddMasterPlanRequest,
  EditMasterPlanLocationRequest,
  EditMasterPlanRequest,
  GetMasterPlanLocationLookupRequest,
  GetMasterPlanLocationsRequest,
  MasterPlan,
  MasterPlanLocation,
  PrivateLocatioDetails,
} from '../domain';
import { CommitPlanRequest } from '../domain/requests/master-plan.ts/commit-plan.request';
import { PlanContainerLocationCount } from '../domain/models/plan-container-location-count';
import { BaseResponse } from '../../data/shared/base.response';
import { PlanContainerLocationCountByProduct } from '../domain/models/plan-container-location-count-by-product';
import { TimeZones } from '../domain/models/time-zones';
import { MasterPlanType } from '../domain/models/master-plan-type';
import { HDMasterPlans } from '../domain/models/master-plans/hd-master-plan';

export abstract class MasterPlansRepository {
  abstract getMasterPlans(
    request: BaseRequest<GetMasterPlansRequest>
  ): Observable<BaseGridResponse<MasterPlan>>;

  abstract addMasterPlan(
    request: AddMasterPlanRequest
  ): Observable<BaseResponse<string>>;

  abstract addMasterPlanLocation(
    request: AddMasterPlanLocationRequest
  ): Observable<boolean>;

  abstract editMasterPlan(request: EditMasterPlanRequest): Observable<boolean>;

  abstract commitPlan(request: CommitPlanRequest): Observable<boolean>;

  abstract getPlanContainerLocations(
    request: BaseRequest<GetMasterPlanLocationsRequest>
  ): Observable<BaseGridResponse<MasterPlanLocation>>;

  abstract getMasterPlanTypes(): Observable<MasterPlanType[]>;

  abstract getMasterPlanLocations(
    request: GetMasterPlanLocationLookupRequest
  ): Observable<MasterPlanLocation[]>;

  abstract deleteMasterPlan(request: string): Observable<boolean>;

  abstract getMasterPlanById(request: string): Observable<MasterPlan>;

  abstract getLocationCountByLocationType(
    request: string
  ): Observable<PlanContainerLocationCount>;

  abstract getLocationCountByProduct(
    request: string
  ): Observable<PlanContainerLocationCountByProduct>;

  abstract getMasterLocationById(
    request: string
  ): Observable<MasterPlanLocation>;

  abstract editMasterPlanLocation(
    request: EditMasterPlanLocationRequest
  ): Observable<boolean>;

  abstract getMasterLocationDetailsById(
    request: string
  ): Observable<PrivateLocatioDetails>;

  abstract getMasterPlanByPlanId(request: string): Observable<MasterPlan>;

  abstract getTimeZones(): Observable<TimeZones[]>;

  abstract getMasterPlansList(): Observable<HDMasterPlans[]>;
}
